import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class TabletIdentifierService {

    private IDENTIFIER_KEY = 'Identifier_key'
    private identifier$$ = new BehaviorSubject<null | string>(null)
    public identifier$ = this.identifier$$.asObservable()

    public async initialize() {
        const identifier = this.getIdentifier()

        if (! identifier) {
            this.regenerateIdentifier()
            return
        }

        this.identifier$$.next(identifier)
    }

    public getIdentifier() {
        return localStorage.getItem(this.IDENTIFIER_KEY)
    }

    private setIdentifier(identifier: string) {
        localStorage.setItem(this.IDENTIFIER_KEY, identifier)
    }

    public regenerateIdentifier() {
        this.setIdentifier(this.generateIdentifier())
        this.identifier$$.next(this.getIdentifier())
    }

    private generateIdentifier(): string {
        return Math.random().toString(16).slice(2, 8).toUpperCase()
    }
}
